/************************* CONSTANTS *************************/
const modalFichaTecnica = document.querySelector(".ficha-tecnica-modal-overlay");
const openFichaTecnicaModalBtn = document.querySelector("#open-ficha-tecnica-modal-btn");
const closeFichaTecnicaButton = document.querySelector(".ficha-tecnica-modal-close");
const fichaTecnicaForm = document.querySelector("#ficha-tecnica-modal-form");
//se comenta porque ya esta declarado en quorterFuntions entonces lo reutilizamos
//const sku = document.querySelector("span[data-product-sku]").innerText;

const sendFichaTecnicaBtn = document.querySelector("#ficha-tecnica-send-btn");
const spanLoaderFicha = document.querySelector("#button-loader-ficha-tecnica");
const successMessageFicha = document.querySelector("#ficha-tecnica-success");

/************************* FUNCTIONS *************************/
function abrirModalFichaTecnica() {
  const modal = document.getElementById("ficha-tecnica-modal");
  const body = document.body;
  const scrollY = window.scrollY;

  modal.style.display = "block";
  body.classList.add("modal-open");
  body.style.top = `-${scrollY}px`;

  // Enfocar el primer input para mejorar experiencia
  setTimeout(() => {
    const firstInput = modal.querySelector("input");
    if (firstInput) {
      firstInput.focus();
    }
  }, 100);
}

function cerrarModalFichaTecnica() {
  const modal = document.getElementById("ficha-tecnica-modal");
  const body = document.body;
  const scrollY = body.style.top;
  body.style.top = "";
  body.classList.remove("modal-open");
  window.scrollTo(0, parseInt(scrollY || "0") * -1);
  modal.style.display = "none";
}

function windowOnClickFichaTecnica(event) {
  if (event.target === modalFichaTecnica) {
    cerrarModalFichaTecnica();
  }
}

async function sendFichaTecnica(e) {
  try {
    e.preventDefault();

    sendFichaTecnicaBtn.disabled = true;
    spanLoaderFicha.style.display = "inline-block";

    const formData = new FormData(e.target);
    const fichaTecnicaData = { sku };

    formData.forEach((value, key) => {
      fichaTecnicaData[key] = value;
    });

    console.log(fichaTecnicaData);

    const emailResponse = await fetch(
      "https://sfc2akxvwaaxslp7iknupzh5ua0itbyj.lambda-url.us-east-1.on.aws/api/ficha-tecnica/sendFicha",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(fichaTecnicaData),
      }
    );

    const emailResult = await emailResponse.json();
    console.log(emailResult);

    sendFichaTecnicaBtn.disabled = false;
    spanLoaderFicha.style.display = "none";
    successMessageFicha.style.display = "inline-block";
    fichaTecnicaForm.reset();
  } catch (error) {
    console.log(error);
    sendFichaTecnicaBtn.disabled = false;
    spanLoaderFicha.style.display = "none";
  }
}

/************************* LISTENERS *************************/
if (modalFichaTecnica && openFichaTecnicaModalBtn && closeFichaTecnicaButton) {
  openFichaTecnicaModalBtn.addEventListener("click", abrirModalFichaTecnica);
  closeFichaTecnicaButton.addEventListener("click", cerrarModalFichaTecnica);
  window.addEventListener("click", windowOnClickFichaTecnica);
  fichaTecnicaForm.addEventListener("submit", sendFichaTecnica);
}